module.exports = __webpack_public_path__ + "static/media/zm.ef2765c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/zm.png
// module id = 2027
// module chunks = 0